export enum Roles {
    ADMINISTRATOR = "DataCutter Administrator",
}